'use client'

import { createContext, useContext } from 'react'
import type { ProductIdentity } from '@/config/product'

/**
 * Contexto da identidade do produto.
 *
 * O RootLayout resolve UMA vez por requisição (via `getProduct()`) e planta aqui.
 * Componentes client leem com `useProduct()` em vez de ler `process.env` — é o
 * que permite trocar a fonte para o banco da instalação sem tocar em nenhum
 * componente.
 */
const ProductContext = createContext<ProductIdentity | null>(null)

export function ProductProvider({
  value,
  children,
}: {
  value: ProductIdentity
  children: React.ReactNode
}) {
  return <ProductContext.Provider value={value}>{children}</ProductContext.Provider>
}

export function useProduct(): ProductIdentity {
  const ctx = useContext(ProductContext)
  if (!ctx) {
    // Falha alto e explica: um componente de marca fora do provider renderizaria
    // o produto errado silenciosamente, que é exatamente o bug que este trabalho existe pra matar.
    throw new Error('useProduct() usado fora do <ProductProvider>. Ele é plantado no RootLayout.')
  }
  return ctx
}
